import React from 'react';

// Import Founder images
import Founder1 from '../../assets/team_images/TeamMember01.jpg';
import Founder2 from '../../assets/team_images/TeamMember02.jpg';
import Founder3 from '../../assets/team_images/TeamMember03.jpg';

function Founder() {

  // Founders info
  const instructors = [
    {
      id: 1,
      name: 'Thongchai Chirattithipun',
      role: 'Founder and IP Owner',
      image: Founder1,
      description: 'Financial Expert and CEO in multinational firms across Thailand and Indo-China (Nestle Thailand & Southeast Asia, L\'Oréal Indo-China, Hewlett-Packard Thailand & Southeast Asia); Author of the WealthyCats And The Inner Wealth Playbook; Creator of the WealthyCats Board Game; Designer of the WealthyCats WealthyClass curriculum.'
    },
    {
      id: 2,
      name: 'Seri Kantajai',
      role: 'Founder & Managing Director',
      image: Founder2,
      description: 'Cultural Orientation Trainer for Indo-Chinese refugees (Consortium of Save the Children, World Education Foundation, and Experiment in International Living); Human Resources Development Expert; Quality & Continuous Improvement Expert; former Hotel Management Executive in Club Med, Starwood Hotels & Resorts, and IHG.'
    },
    {
      id: 3,
      name: 'Panupan Nuntapredawat',
      role: 'Director',
      image: Founder3,
      description: 'Experienced entrepreneur in trading, education, and consulting with expertise in lean entrepreneurship, operational excellence, and strategic partnerships. Focused on innovative learning models and strategic facilitation to help SMEs bridge strategy and execution for sustainable growth..'
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-yellow-50 via-white to-orange-50">
      {/* Hero Section */}
      <section className="relative pt-32 pb-16 md:pt-40 md:pb-20">
        <div className="absolute top-10 left-10 w-96 h-96 bg-[#FED700]/20 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-[#F4900C]/20 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse"></div>
        
        <div className="container-custom relative z-10">
          <div className="text-center max-w-4xl mx-auto">

            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              Team H <span className="text-[#F4900C]">Founders</span>
            </h1>
            
            <p className="text-xl text-gray-600">
              Our facilitators bring world-class experience from the private, public,
              and social sectors
            </p>
          </div>
        </div>
      </section>

      {/* Instructors Section */}
      <section className="py-16 bg-white">
        <div className="container-custom">
          <div className="space-y-20">
            {instructors.map((instructor, index) => (
              <div 
                key={instructor.id}
                className={`grid lg:grid-cols-2 gap-12 items-center ${
                  index % 2 === 1 ? 'lg:flex-row-reverse' : ''
                }`}
              >
                {/* Founder Image */}
                <div className={`${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                  <div className="relative">
                    <div className="absolute inset-0 bg-gradient-to-r from-[#FED700] to-[#F4900C] rounded-2xl transform rotate-3"></div>
                    <div className="relative bg-white rounded-2xl shadow-2xl overflow-hidden">
                      <img 
                        src={instructor.image}
                        alt={instructor.name}
                        className="w-full h-auto object-cover"
                      />
                    </div>
                  </div>
                </div>

                {/* Founder Details */}
                <div className={`${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                    <h2 className="text-3xl font-bold text-gray-900 mb-2 tracking-tight">
                        {instructor.name}
                    </h2>
                  <div className="inline-block bg-gradient-to-r from-[#FED700]/20 to-[#F4900C]/20 px-4 py-2 rounded-full mb-4">
                    <span className="font-semibold text-gray-800">{instructor.role}</span>
                  </div>

                  <p className="text-lg text-gray-700 leading-relaxed">
                    {instructor.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
}

export default Founder;